import { Box, Button } from "grommet";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { Notification } from "grommet-icons";
import { checkQuizStatus } from "../../services/dashboardService";

function HomeButtons({ user_id, flag }) {
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      const quizStarted = await checkQuizStatus(user_id);
      setShowButton(quizStarted);
    };
    fetchData();
  }, [user_id]);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <Box
      alignSelf="end"
      alignContent="end"
      direction="row"
      margin="medium"
      gap="medium"
    >
      {flag === 0 && (
        <Button
          primary
          label="Home"
          onClick={() => {
            navigate(`/add-proficiency/${user_id}`);
          }}
        />
      )}

      {/* <Button
        primary
        label="Dashboard"
        onClick={() => {
          navigate(`/dashboard/user/${user_id}`);
        }}
      /> */}
      {showButton ? (
        <Box align="center" justify="center" pad="small">
          <Button
            icon={
              <Notification
                size="medium"
                style={{ animation: "shake 1s infinite ease-in-out" }}
                color="status-critical"
              />
            }
            label="New assessments available!"
            primary
            onClick={() => navigate(`/user/user-assessments/${user_id}`)}
            style={{
              background: "#00C08B",
              color: "#fff",
              fontWeight: "bold",
              letterSpacing: "0.03em",
              borderRadius: "24px",
              padding: "12px 24px",
              boxShadow: "0 0 8px rgba(0,192,139,0.6)",
              animation: "glow 2s ease-in-out infinite",
            }}
          />
          <style>{`
        @keyframes glow {
          0%, 100% {
            box-shadow: 0 0 8px rgba(0,192,139,0.6);
          }
          50% {
            box-shadow: 0 0 16px rgba(0,192,139,1);
          }
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20%, 60% { transform: translateX(-3px); }
          40%, 80% { transform: translateX(3px); }
        }
      `}</style>
        </Box>
      ) : null}
      {/* {user.role === "manager" && (
        <Button
          label="Go to manager dashboard"
          onClick={() => {
            navigate(`/${user.user_id}/manager/dashboard`);
          }}
          primary
        />
      )} */}
    </Box>
  );
}

export default HomeButtons;
